import { ProjectPage } from "../../../project.page";

import { Router, RouterModule } from "@angular/router";

import { ActivatedRoute } from "@angular/router";
import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxButtonModule,
  DxDataGridModule,
  DxDataGridComponent,
  DxTabPanelModule,
  DxTextBoxModule,
  DxSelectBoxModule,
  DxNumberBoxModule,
  DxToastModule,
  DxDropDownBoxModule,
  DxTreeViewModule,
  DxValidatorModule,
  DxCheckBoxModule,
  DxFormModule,
  DxTextAreaModule,
  DxPopupModule,
  DxTreeListComponent, DxValidationGroupModule
} from "devextreme-angular";
import DataGrid from "devextreme/ui/data_grid";
import { ProjectCostTemplatesService } from "src/app/services/project-cost-templates.service ";
import { AppGlobals } from "src/app/app.globals";
import { ProjectCostPlanService } from "src/app/services/project-cost-plan.service";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { ProjectInfoService } from "src/app/services/project-info.service";
import { GlobalPopupService } from "src/app/components/generic-popup/presets/global-popup/global-popup.service";
import { ProjectStatus } from "../../../../../../interfaces/entities/project";
import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
import { TemplatesService } from "src/app/services/templates.service";
import { sizeUnitFor, perUnitLabel } from "./size-unit";

import { SearchableDropdownDirective } from '../../../../../../directives/searchable-dropdown.directive';
interface TemplateFile {
  taskId: Number;
  file: File;
}

@Component({
    selector: "app-project-costs-budget",
    imports: [
        CommonModule,
        DxButtonModule,
        DxDataGridModule,
        DxTabPanelModule,
        DxTextBoxModule,
        DxSelectBoxModule,
        DxNumberBoxModule,
        DxToastModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxValidatorModule,
        DxCheckBoxModule,
        DxFormModule,
        DxTextAreaModule,
        DxPopupModule, DxValidationGroupModule,
        GpdButtonComponent,
        SearchableDropdownDirective
    ],
    providers: [ProjectPage],
    templateUrl: "./project-costs-budget.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./project-costs-budget.page.css"]
})
export class ProjectCostsBudgetPageComponent {
  confirmText = $localize`:@@confirmCaps:CONFIRM`;
  cancelText = $localize`:@@cancelCaps:CANCEL`;
  required = $localize`:@@required:Required`;

  type: any = "";
  message: any = "";
  toastVisible: boolean = false;
  projectPlanCosts: any = {
    id: null,
    templateName: null,
    areaTypeId: null,
    sizeRange: null,
    templateCosts: [],
  };
  selectedTemplate: any = {
    id: null,
    templateName: null,
    areaTypeId: null,
    sizeRange: null,
    templateCosts: [],
  };

  selectedTabIndex: any = 0;
  costTemplates: any = [
    {
      id: 0,
      name: "Small Roof Template",
      areaType: "dach 1",
      size: 1000,
      costs: [
        {
          id: 1,
          category: "Vertrieb",
          units: "Euros",
          attractUst: true,
          costNett: 10000,
          milestone: 1,
          milestoneOffset: 1,
          milestoneOffsetDirection: "after",
          notes: "",
        },
        {
          id: 2,
          category: "Akquiseprovision",
          units: "€/kWp",
          attractUst: false,
          costNett: 40,
          milestone: 1,
          milestoneOffset: 1,
          milestoneOffsetDirection: "before",
          notes: "",
        },
      ],
    },
  ];

  @ViewChild("masterGrid") masterGrid: DxDataGridComponent;
  @ViewChild("selectedTemplateGrid") selectedTemplateGrid: DxDataGridComponent;
  @ViewChild("treeListCategory") treeListCategory: DxTreeListComponent;

  @ViewChildren(DxDataGridComponent) dataGrids: QueryList<DxDataGridComponent>;
  userPermissions: any = AppGlobals.UserPermissions;
  currentEditDetailGrid: any;
  projectSizeRanges: any = [];
  projectAreaTypes: any = [];
  // Area types with their sizeUnit (WI 3211) - projectAreaTypes above is a plain {itemId,itemName} lookup list.
  areaTypes: any[] = [];
  // The project's own area type (WI 3211 fix round 1) - NOT projectPlanCosts.areaTypeId, which
  // is the template currently being edited and is null on a fresh load.
  projectAreaTypeId: number | null = null;

  get sizeUnit(): string {
    return sizeUnitFor(this.areaTypes, this.projectAreaTypeId);
  }

  loadProjectAreaType(): Promise<void> {
    return this.projectInfoService
      .getProjectHeaddata({ ProjectHeaddataItem: { projectId: this.projectId } })
      .then((result) => {
        if (!result.hasError) this.projectAreaTypeId = result.projectHeaddataItem?.areaTypeId ?? null;
      });
  }
  costCategories: any = [];
  templates: any = [];
  selectedTemplateCost: any = {
    costPlanId: null,
    projectCostTemplateId: null,
    isSiteCost: false,
    isKwpCost: false,
    costCategoryId: null,
    costNett: null,
    attractsUst: false,
    ust: null,
    costMilestoneId: null,
    milestoneOffsetValue: null,
    milestoneOffsetDirection: null,
    notes: null,
  };
  milestones: any = [];
  treeDataSourceSorted: any = [];
  planCosts: any = [];
  templateCostsToAdd: any = [];

  isTreeBoxOpened: boolean = false;
  importTemplateVisible: boolean = false;
  addToExsistingCostsPopupVisible: boolean = false;
  deleteSelectedCostsPopupVisible: boolean = false;
  selectedCostPlanIds: number[] = [];
  freezeBudgetPopupVisible: boolean = false;
  unfreezeBudgetPopupVisible: boolean = false;

  milestoneOffsetDirections: any = [
    { text: 'Before', id: 1 },
    { text: 'After', id: 2 }
  ]
  titleRequired: string = $localize`Template Name is Required.`;
  areaTypeRequired: string = $localize`Area Type is Required.`;
  sizeRangeRequired: string = $localize`Size Range is Required.`;
  costNettRequired: string = $localize`Cost Nett is Required.`;
  milestoneRequired: string = $localize`Milestone information is Required.`;

  deletePlanCostTitle: string = $localize`Confirm Delete`;

  addToExisitngCostsText: string = $localize`Add Template Costs`;

  freezeBudgetText: string = $localize`:@@freezeBudget:Freeze Budget`;
  unfreezeBudgetText: string = $localize`:@@unfreezeBudget:Unfreeze Budget`;
  freezeBudgetTitle: string = $localize`:@@confirmFreezeBudget:Confirm Freeze`;
  unfreezeBudgetTitle: string = $localize`:@@confirmUnfreezeBudget:Confirm Unfreeze`;
  freezeBudgetMessage: string = $localize`:@@freezeBudgetMessage:Freezing the budget will prevent any further changes until an administrator unfreezes it. Are you sure you want to continue?`;
  unfreezeBudgetMessage: string = $localize`:@@unfreezeBudgetMessage:Unfreezing the budget will allow changes to be made again. Are you sure you want to continue?`;

  projectId: any = "";

  nettFormat: any = "#,##0.00 €";

  planIsInDraft: boolean | null = null;

  costNettEditiorOptions: any = { maxLength: 50, format: this.nettFormat };
  EPKWFormatting: boolean = false;
  projectStatus: string;

  constructor(
    private projectCostTemplatesService: ProjectCostTemplatesService,
    private projectCostPlanService: ProjectCostPlanService,
    private router: Router,
    private projectInfoService: ProjectInfoService,
    private globalPopupService: GlobalPopupService,
    private activityLog: ActivityLogService,
    private templateService: TemplatesService
  ) { }
  /* 

    DeleteProjectCostOnTemplate{
        "Cost": {
            "Id": 4
        },
        "Language": "German"
    }
    */

  ngOnInit() {
    this.getCostTempaltes();

    let url = this.router.url;
    let splitUrl = url.split("/");
    this.projectId = parseInt(splitUrl[4]);
    this.activityLog.logView({ Section: ActivitySection.PROJECT_COST_BUDGET, ProjectId: this.projectId });

    this.projectInfoService.getGlobalProjectInfo({ ProjectId: this.projectId }).then(result => {
      if (!result.hasError) this.projectStatus = result.globalProjectInfoResultItem?.status;
    });

    // The grid's cellTemplate is a stable reference (on purpose, see cellTemplate below) - a row
    // rendered before both unit lookups resolve shows a bare "€" and nothing tells the grid to
    // repaint once the unit becomes known. So the plan costs load waits for both (WI 3211 fix
    // round 2). Each lookup is caught individually - ApiBaseService.httpRequest rejects on a
    // network/5xx failure, and a failed unit lookup must degrade to a bare "€", never to a
    // permanently empty grid (WI 3211 fix round 3).
    Promise.all([
      this.templateService.getAreaTypes().then(result => {
        if (!result.hasError) this.areaTypes = result.areaTypes;
      }).catch(() => undefined),
      this.loadProjectAreaType().catch(() => undefined),
    ]).then(() => this.getAllPlanCostsForProject());
  }

  getAllPlanCostsForProject(): void {
    let url = this.router.url;
    let splitUrl = url.split("/");

    let ProjectId = parseInt(splitUrl[4]);
    this.projectCostPlanService.getAllPlanCostsForProject({ ProjectId }).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.selectedTemplateGrid?.instance.clearSelection();
          this.planCosts = result.planCosts;
          for (let i = 0; i < this.planCosts.length; i++) {
            this.planCosts[i].ust = this.planCosts[i].ust / 100;
            /*             if (this.planCosts[i].ust != 0 && this.planCosts[i].ust != null) {
                          this.planCosts[i].attractsUst = true;
                        } else {
                          this.planCosts[i].attractsUst = false;
                        } */
          }
        }
        this.planIsInDraft = result.planIsInDraft;
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  loadTemplate(projectId: any, templateId: any): void {
    let loadTemplateData = {
      ProjectId: projectId,
      TemplateId: templateId,
      Language: "German",
    };

    this.projectCostPlanService
      .importProjectTemplateIntoProjectPlan(loadTemplateData)
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.saveToast({
              type: "success",
              feedback: $localize`:@@loaded:Loaded`,
            });
            this.getAllPlanCostsForProject();
            this.getCostTempaltes();
            this.selectedTemplateGrid.instance.refresh();
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  getCostTempaltes() {
    this.projectCostTemplatesService.getAllProjectCostTemplates({}).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.costTemplates = result.projectCostTemplates;
          this.projectSizeRanges = result.projectSizeRanges;
          this.projectAreaTypes = result.projectAreaTypes;
          this.costCategories = result.costCategories;
          this.milestones = result.milestones;
          this.treeDataSourceSorted = [];
          this.assignTreeListIDs(this.costCategories, 0, 0);
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  saveToast(e: any): void {
    const type = e.type ? "success" : "error";
    if ((this.type = "success")) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage(
        $localize`:@@errorTryAgain:ERROR: There was an error, please try again.`
      );
    }
    this.type = type;
    this.toastVisible = true;
  }

  insertTemplate(e: any): void {
    e.data = {
      id: null,
      templateName: null,
      areaTypeId: null,
      sizeRange: null,
      templateCosts: [],
    };
  }

  onInitNewRow(e: any): void {
    e.data = {
      id: null,
      templateName: null,
      areaTypeId: null,
      sizeRange: null,
      templateCosts: [],
    };
    this.projectPlanCosts = e.data;
  }

  initEditCostTemplate(e: any): void {
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.selectedTemplateGrid.instance.editRow(e.rowIndex);
  }

  onCostRowUpdated(e: any, cost: any): void {
    //  this.selectedTemplateCost.projectCostTemplateId = cost.data.id;
    this.writeProjectCostTemplateCost(this.selectedTemplateCost);
  }

  changeMilestone(e: any): void {
    this.selectedTemplateCost.costMilestoneId = e.selectedItem.itemId;
    this.selectedTemplateCost.costMilestoneName = e.selectedItem.itemName;
  }

  onCostRowInserted(e: any): void { }

  onCostEditorPrepared(e: any): void { }

  onCostEditCanceling(e: any): void {
    this.selectedTemplateGrid.instance.cancelEditData();
    this.getAllPlanCostsForProject();
    this.getCostTempaltes();
    this.selectedTemplateGrid.instance.refresh();
    this.selectedTemplateCost = {
      costPlanId: null,
      projectCostTemplateId: null,
      isSiteCost: false,
      isKwpCost: false,
      costCategoryId: null,
      costNett: null,
      attractsUst: false,
      ust: null,
      costMilestoneId: null,
      milestoneOffsetValue: null,
      milestoneOffsetDirection: null,
      notes: null,
    };
  }

  showCost(e: any, data: any): void { }

  writeProjectCostTemplateCost(templateCost: any) {
    let url = this.router.url;
    let splitUrl = url.split("/");

    let PlanCost = {
      ProjectId: parseInt(splitUrl[4]),
      CostPlanId: templateCost.costPlanId,
      CostCategoryId: templateCost.costCategoryId,
      CostCategoryName: templateCost.costCategoryName,
      IsSiteCost: templateCost.isSiteCost,
      IsKwpCost: templateCost.isKwpCost,
      CostNett: templateCost.costNett,
      AttractsUst: templateCost.attractsUst,
      Ust: templateCost.ust * 100,
      CostMilestoneId: templateCost.costMilestoneId,
      CostMilestoneName: templateCost.costMilestoneName,
      MilestoneOffsetValue: templateCost.milestoneOffsetValue,
      MilestoneOffsetDirection: templateCost.milestoneOffsetDirection,
      Notes: templateCost.notes,
    };
    //   "AttractsUst": templateCost.attractsUst,
    if (templateCost.costPlanId === null) {
      this.projectCostPlanService.addCostToProjectCostPlan({ PlanCost }).then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.saveToast({
              type: "success",
              feedback: $localize`:@@saved:Saved`,
            });

            this.selectedTemplateGrid.instance.cancelEditData();
            this.getAllPlanCostsForProject();
            this.getCostTempaltes();

            this.selectedTemplateCost = {
              costPlanId: null,
              projectCostTemplateId: null,
              isSiteCost: false,
              isKwpCost: false,
              costCategoryId: null,
              costNett: null,
              attractsUst: false,
              ust: null,
              costMilestoneId: null,
              milestoneOffsetValue: null,
              milestoneOffsetDirection: null,
              notes: null,
            };
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    } else {
      this.projectCostPlanService.editCostOnProjectCostPlan({ PlanCost }).then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.saveToast({
              type: "success",
              feedback: $localize`:@@saved:Saved`,
            });

            this.selectedTemplateGrid.instance.cancelEditData();
            this.getAllPlanCostsForProject();
            this.getCostTempaltes();
            this.selectedTemplateGrid.instance.refresh();

            this.selectedTemplateCost = {
              costPlanId: null,
              projectCostTemplateId: null,
              isSiteCost: false,
              isKwpCost: false,
              costCategoryId: null,
              costNett: null,
              attractsUst: false,
              ust: null,
              costMilestoneId: null,
              milestoneOffsetValue: null,
              milestoneOffsetDirection: null,
              notes: null,
            };
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }
  }

  private get pausedProjectWarning(): string {
    return this.projectStatus ===  ProjectStatus.INACTIVE
      ? $localize`:@@editInactiveProjectWarning:The project is inactive. To make changes, set the status of the project to "Active".`
      : $localize`:@@editCanceledProjectWarning:The project is canceled. To make changes, set the status of the project to "Active".`;
  }

  initFreezeBudget(): void {
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.freezeBudgetPopupVisible = true;
  }

  freezeBudget(): void {
    this.freezeBudgetPopupVisible = false;
    this.projectCostPlanService.freezeProjectCostBudget({ ProjectId: this.projectId }).then(
      (result) => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({ type: "success", feedback: $localize`:@@budgetFrozen:Budget frozen` });
          this.getAllPlanCostsForProject();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  initUnfreezeBudget(): void {
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.unfreezeBudgetPopupVisible = true;
  }

  unfreezeBudget(): void {
    this.unfreezeBudgetPopupVisible = false;
    this.projectCostPlanService.unfreezeProjectCostBudget({ ProjectId: this.projectId }).then(
      (result) => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({ type: "success", feedback: $localize`:@@budgetUnfrozen:Budget unfrozen` });
          this.getAllPlanCostsForProject();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  onCostEditingStart(e: any): void {
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      e.cancel = true;
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.selectedTemplateCost = e.data;
  }

  addCostRow(e: any): void {
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    /*         console.log(id);
                console.log(this.dataGrids); */
    console.log("addCostRow", e);
    this.selectedTemplateCost = {
      costPlanId: null,
      projectCostTemplateId: null,
      isSiteCost: false,
      isKwpCost: false,
      costCategoryId: null,
      costNett: null,
      attractsUst: false,
      ust: null,
      costMilestoneId: null,
      milestoneOffsetValue: null,
      milestoneOffsetDirection: null,
      notes: null,
    };
    this.selectedTemplateGrid.instance.addRow();
  }

  onCostSelectionChanged(e: any): void {
    this.selectedCostPlanIds = e.selectedRowKeys;
  }

  initDeleteSelectedCosts(): void {
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.deleteSelectedCostsPopupVisible = true;
  }

  deleteSelectedCosts(): void {
    this.deleteSelectedCostsPopupVisible = false;
    this.projectCostPlanService
      .deleteCostsOnProjectCostPlan({ ProjectId: this.projectId, CostPlanIds: this.selectedCostPlanIds })
      .then(
        (result) => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else this.saveToast({ type: "success", feedback: $localize`:@@deleted:Deleted` });
          // Reload on failure too: a cost deleted elsewhere would otherwise stay selected and fail every retry.
          this.getAllPlanCostsForProject();
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
          this.getAllPlanCostsForProject();
        }
      );
  }

  initEditCost(e: any, item: any): void {
    // Keep the click from reaching the row, which would toggle its selection checkbox.
    e.event?.stopPropagation();
    if (this.projectStatus === ProjectStatus.INACTIVE || this.projectStatus === ProjectStatus.CANCELED) {
      this.globalPopupService.showWarningPopup(this.pausedProjectWarning);
      return;
    }
    this.selectedTemplateGrid.instance.editRow(item.rowIndex);
  }

  isKwpCostChanged(e: any): void {
    if (e.value === true) {
      this.EPKWFormatting = true;
    } else {
      this.EPKWFormatting = false;
    }
  }

  iskwpInitialized(e: any): void {
    this.isKwpCostChanged({ value: e.isKwpCost });
  }

  // Exposed for templates - perUnitLabel('') must render a bare "€", never a dangling "€/".
  perUnitLabel = perUnitLabel;

  cellTemplate = (container: any, options: any) => {
    const otherColumnValue = options.data.isKwpCost;
    const targetValue = options.value;
    const label = otherColumnValue === true ? perUnitLabel(this.sizeUnit) : "€";
    this.nettFormat = `#,##0.00 ${label}`;
    container.textContent = `${targetValue.toLocaleString("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} ${label}`;
  };

  addCustomSizeRangeValue(e: any) {
    const newItem = { itemName: e.text };
    // Add the new item to the items array if it doesn't already exist
    if (this.projectSizeRanges === undefined) {
      let emptyArray = [];
      this.projectSizeRanges = emptyArray;
      if (
        this.projectSizeRanges.length > 0 ||
        !this.projectSizeRanges.includes(newItem)
      ) {
        this.projectSizeRanges.push(newItem);
      }
    } else {
      if (
        this.projectSizeRanges.length > 0 ||
        !this.projectSizeRanges.includes(newItem)
      ) {
        this.projectSizeRanges.push(newItem);
      }
    }
    // Return the new item as the value for the select box
    e.customItem = newItem;
  }

  editTemplate(e: any) {
    this.projectPlanCosts = e.data;
  }

  treeView_itemSelectionChanged(e: any, item: any) {
    // onInitialized also calls this with no itemData — ignore that case.
    if (!e?.itemData) {
      return;
    }
    // Allow selecting any category, including parent/main categories that have subcategories.
    item.costCategoryId = e.itemData.id;
    item.costCategoryName = e.itemData.categoryName;
    this.isTreeBoxOpened = false;
  }

  async assignTreeListIDs(categories: any, cat: any, subCat: any) {
    for (let i = 0; i < categories.length; i++) {
      if (cat === 0) {
        categories[i].treeId = i + 1;

        this.treeDataSourceSorted.push(categories[i]);
      } else {
        if (subCat != 0) {
          categories[i].treeId = cat + "_" + subCat + "_" + (i + 1);
          categories[i].treeCategoryId = cat + "_" + subCat;
          this.treeDataSourceSorted.push(categories[i]);
        } else {
          this.treeDataSourceSorted.push(categories[i]);
        }
      }
      // console.log(this.treeDataSourceSorted);

      if (categories[i].subCategories.length > 0) {
        let subCategory = categories[i].subCategories;

        for (let a = 0; a < subCategory.length; a++) {
          let idlayer = "_";
          categories[i].subCategories[a].treeId =
            categories[i].treeId + idlayer + (a + 1);
          categories[i].subCategories[a].treeCategoryId = categories[i].treeId;
          this.treeDataSourceSorted.push(categories[i].subCategories[a]);
          // console.log(this.treeDataSourceSorted);
          //category = subCategory[i];
          if (categories[i].subCategories[a].subCategories.length > 0) {
            this.assignTreeListIDs(
              categories[i].subCategories[a].subCategories,
              i + 1,
              a + 1
            );
          }
        }
      }
      //  console.log(this.treeDataSourceSorted);
    }
  }

  deleteTemplate(template: any) {
    this.projectPlanCosts = template.data;
    this.deleteProjectCostTemplate(this.projectPlanCosts);
  }

  deleteProjectCostTemplate(template: any): void {
    let ProjectCostTemplate = {
      Id: template.id,
    };

    this.projectCostTemplatesService
      .deleteProjectCostTemplate({ ProjectCostTemplate })
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.saveToast({
              type: "success",
              feedback: $localize`:@@deleted:Deleted`,
            });
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  setAreaType(e: any): void {
    this.projectPlanCosts.areaTypeId = e.value;
  }

  getTemplate(e: any): void { }

  importTemplate(e: any): void {
    this.importTemplateVisible = true;
  }

  openTemplate(e: any): void {
    if (e.row.isEditing === false) {
      this.importTemplateVisible = false;
      //  If no costs added already, just push into the array, if cost already there then ask if want to add themplate costs to existing costs
      if (this.planCosts.length <= 0) {
        this.addTemplateCosts(e.data);
      } else {
        this.addToExsistingCostsPopupVisible = true;
        ///Get costs from template to add(Need to do a call)
        this.templateCostsToAdd = e.data;
      }
    }
  }
  addCostTemplate(): void {
    this.router.navigate(["config/templates-costs-templates"]);
    //// need to add a call to navigate to templte with back routing or open it up in a popup, as a component???
  }

  onTemplateEditCanceling(e: any): void {
    this.masterGrid.instance.cancelEditData();
  }

  saveCostTemplate(templateData: any) {
    this.writeProjectcostTemplate(this.selectedTemplate);
  }

  writeProjectcostTemplate(template: any) {
    let ProjectCostTemplate = {
      Id: template.id,
      TemplateName: template.templateName,
      AreaTypeId: template.areaTypeId,
      SizeRange: template.sizeRange,
      TemplateCosts: template.templateCosts,
    };
    this.projectCostTemplatesService
      .writeProjectcostTemplate({ ProjectCostTemplate })
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.saveToast({
              type: "success",
              feedback: $localize`:@@saved:Saved`,
            });
            this.getCostTempaltes();
            this.masterGrid.instance.cancelEditData();
            this.masterGrid.instance.refresh();
            this.selectedTemplate = {
              id: null,
              templateName: null,
              areaTypeId: null,
              sizeRange: null,
              templateCosts: [],
            };
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
  }

  addTemplateCosts(items: any): void {
    /*  for (let i = 0; i < items.length; i++) {
             this.selectedTemplate.templateCosts.push(items[i]);
             // Do the save afterwards for each addition;
         }
  */
    let url = this.router.url;
    let splitUrl = url.split("/");
    this.loadTemplate(parseInt(splitUrl[4]), items.id);
    this.addToExsistingCostsPopupVisible = false;
  }

  refreshTreeList(): void {
    this.treeListCategory.instance.refresh();
  }

  logDropBoxData(e: any, t: any): void {
    console.log("logDropBoxData", e, t);
  }
}
